/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.8.2",
  "gitBuildTime": "2026-03-17T20:48:34.048Z",
  "gitBuildVersion": "2.8.2",
  "gitCommitId": "eab00ac",
  "gitCommitIdFull": "eab00ac319fc2aa1ec96d0a22afee172d54d0a8c",
  "gitCommitTime": "2026-03-17T20:47:03.000Z",
  "version": "2.8.2-2026-03-17T20:47:03.000Z-(eab00ac)"
};
